<div class="dialog">
    <div class="dialog-body">
        <form class="left" #form="ngForm">
            <div class="form-row form-required">
                <input #searchInput
                    type="text"
                    name="term"
                    autofocus
                    autocomplete="off"
                    placeholder="{{ 'shared.dialog.search-brands.heading' | translate }}..."
                    [(ngModel)]="term">
            </div>

            <div class="buttons-flex">
                <button type="button" class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</button>
                <button class="button button-primary" (click)="onSubmit(form)">{{ 'shared.button.search' | translate }}</button>
            </div>
        </form>

        <div class="results">
            <mat-dialog-content>
                <app-loading *ngIf="searching"></app-loading>

                <div *ngIf="!searching" class="selector-list">
                    <div *ngFor="let item of results" class="selector-list-item">
                        <div class="selector-list-image">
                            <img [src]="item.logo | imageFromApi" [alt]="item.name">
                        </div>
                        <div class="selector-list-name">
                            {{ item.name }}
                        </div>
                        <div class="selector-list-button">
                            <a (click)="onSelect(item)" class="button button-basic-primary">
                                {{ 'shared.button.select' | translate }}
                            </a>
                        </div>
                    </div>
                </div>
            </mat-dialog-content>
        </div>
    </div>
</div>
